export default __webpack_public_path__ + "static/media/stay-tuned.8de81c90.svg";